/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {Version} from '@angular/core';

/** Current version of the Angular Component Development Kit. */
export const VERSION = new Version('11.0.2');
